import VendorSpinResultMSTState from '../../../vendor_core/src/states/minSpinTimeStates/VendorSpinResultMSTState';
import CoinModel from '../../model/CoinModel';
export default class CCSpinResultState extends VendorSpinResultMSTState {
    protected stopReels(): void {
        CoinModel.clearTextOverlays();
        super.stopReels();
    }
}
